import React, { Component } from 'react';
import { green } from 'sushiweb/tokens/color';
import { copyToClipboard } from '../../components/commons/CommonMethods';
import { WFHCall } from '../../components/commons';
import { viewText } from '../../images/images';
import Linkify from 'react-linkify';
import './copyText.scss';
import { Check, Copy } from 'lucide-react';

export default class CopyText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCopied: false,
      isMask: true,
    };
    this.timerId = null;
  }

  componentWillUnmount = () => {
    clearTimeout(this.timerId);
  };

  copyText = (text) => {
    copyToClipboard(text);
    this.setState({
      isCopied: true,
    });
    this.timerId = setTimeout(() => {
      this.setState({
        isCopied: false,
      });
    }, 1000);
  };

  unmaskTitle = () => {
    this.setState({
      isMask: false,
    });
  };

  componentDecorator = (href, text, key) => (
    <a
      href={href}
      key={key}
      target='_blank'
      rel='noopener noreferrer'
      style={{ color: 'mediumblue', textDecoration: 'none' }}
    >
      {text}
    </a>
  );

  render() {
    const {
      title,
      isWFH = false,
      orderId,
      userId = null,
      masking,
      maskingCount,
      calledTo,
      calledToType = null,
      type = 'text',
      customClass,
      isLink = false,
      role = '',
      dontShowCopyIcon = false,
      iconColor = null,
      position = 'bottom',
      maskEverything = false,
    } = this.props;

    if (!title) return null;

    const { isCopied, isMask } = this.state;

    let titleStr = String(title);

    return (
      <div
        className='copyWrapper !tw-pl-0'
        data-dd-privacy={maskEverything ? 'mask' : 'allow'}
      >
        {masking && isMask ? (
          <React.Fragment>
            <span className='textToCopy mask'>
              {type === 'email' ? (
                <React.Fragment>
                  {titleStr.substr(0, maskingCount)}
                  {'x'.repeat(8)}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {titleStr.substr(0, maskingCount)}
                  {'x'.repeat(8)}
                </React.Fragment>
              )}
            </span>
            <span
              className='pointer icon iconMarginL'
              onClick={this.unmaskTitle}
              data-dd-action-name='Unmask Text'
            >
              <img src={viewText} alt='' />
            </span>
          </React.Fragment>
        ) : !dontShowCopyIcon ? (
          <div
            onClick={this.copyText.bind(this, titleStr)}
            className='tw-cursor-pointer tw-flex tw-text-center tw-gap-2 tw-h-full tw-relative'
            data-dd-action-name='Copy Text'
          >
            <span className={`textToCopy ${customClass ? customClass : ''}`}>
              {isLink ? (
                <Linkify componentDecorator={this.componentDecorator}>
                  {titleStr}
                </Linkify>
              ) : (
                <React.Fragment>{titleStr}</React.Fragment>
              )}
            </span>
            <span className='tw-flex tw-items-center tw-relative tw-w-6'>
              <Copy
                size={14}
                color={iconColor ? iconColor : green.z700}
                className={`tw-transition-all tw-absolute tw-duration-300 tw-ease-out ${
                  isCopied ? 'tw-opacity-0' : 'tw-opacity-100'
                }`}
              />
              <Check
                size={16}
                color='#318616'
                className={`tw-transition-all tw-absolute tw-duration-300 tw-ease-out ${
                  isCopied
                    ? 'tw-opacity-100 tw-scale-100'
                    : 'tw-opacity-0 tw-scale-75'
                }`}
              />
            </span>
            {isCopied && (
              <div
                className={`tw-shadow tw-absolute tw-z-50 ${
                  position === 'right'
                    ? 'tw-ml-40 tw-top-1/2 -tw-translate-y-1/2'
                    : '-tw-right-9 tw-top-0 tw-mt-9'
                } tw-whitespace-nowrap tw-rounded-xl tw-font-medium tw-text-white tw-bg-base-green tw-px-3 tw-py-[0.8rem] tw-text-[1.3rem] tw-leading-none tw-w-fit`}
              >
                Copied!
              </div>
            )}
          </div>
        ) : (
          <React.Fragment>
            <span className='textToCopy mask marginR'>
              {type === 'email' ? (
                <React.Fragment>
                  {titleStr.substr(0, maskingCount)}
                  {'x'.repeat(8)}
                </React.Fragment>
              ) : (
                <div className='tw-mr-2'>
                  {titleStr.substr(0, maskingCount)}
                  {'x'.repeat(8)}
                </div>
              )}
            </span>
          </React.Fragment>
        )}

        {isWFH ? (
          <WFHCall
            orderId={orderId}
            userId={userId}
            title={titleStr}
            calledTo={calledTo}
            calledToType={calledToType}
            role={role}
          />
        ) : null}
      </div>
    );
  }
}
